import { render, staticRenderFns } from "./AdddispositionDia.vue?vue&type=template&id=2f5a83be"
import script from "./AdddispositionDia.vue?vue&type=script&lang=js"
export * from "./AdddispositionDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports